import type { ReactElement } from 'react'

import type { Poem } from '@maria-cavalheiro-website/shared-types'
import { PillLink } from '@maria-cavalheiro-website/shared-ui-web'

import { poemPath } from '../../app/routes.ts'

export interface PoemSubNavProps {
  readonly previous: Poem
  readonly next: Poem
}

const INDEX_LABEL = 'Todos os poemas'
/** Absolute, not the design's bare `#poemas` — that anchor scrolls nowhere here. */
const INDEX_HREF = '/#poemas'

const NAV_LABEL = 'Navegação entre poemas'
const PREVIOUS_PREFIX = 'Poema anterior:'
const NEXT_PREFIX = 'Próximo poema:'

/**
 * The second sticky bar: index link on the left, prev/next on the right.
 *
 * TRUNCATION AND NAMES: the visible titles are clipped to 16ch by CSS, which would
 * otherwise leave a screen-reader user with an accessible name ending mid-word —
 * a § 2.4.4 failure. So the visible span is `aria-hidden` and the link carries a
 * full visually-hidden name ("Poema anterior: Pombas no telhado"). The design put
 * the full title in `title=` and let the clipped text be the name.
 */
export function PoemSubNav({ previous, next }: PoemSubNavProps): ReactElement {
  return (
    <div className="poem-sub-nav">
      <nav className="poem-sub-nav__inner" aria-label={NAV_LABEL}>
        <PillLink variant="ghost" href={INDEX_HREF} icon="list">
          {INDEX_LABEL}
        </PillLink>

        <div className="poem-sub-nav__pair">
          <PillLink
            variant="secondary"
            href={poemPath(previous.slug)}
            rel="prev"
            icon="chevron-left"
            accessibleName={`${PREVIOUS_PREFIX} ${previous.title}`}
          >
            <span className="poem-sub-nav__title" aria-hidden="true">
              {previous.title}
            </span>
          </PillLink>

          <PillLink
            variant="secondary"
            href={poemPath(next.slug)}
            rel="next"
            iconAfter="chevron-right"
            accessibleName={`${NEXT_PREFIX} ${next.title}`}
          >
            <span className="poem-sub-nav__title" aria-hidden="true">
              {next.title}
            </span>
          </PillLink>
        </div>
      </nav>
    </div>
  )
}
